import { CircularProgress, Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(16),
    },
}))

const GlobalBusy = () => {
    const classes = useStyles()
    return (
        <Grid
            container
            justify="center"
            alignContent="center"
            className={classes.paper}
            item
            xs={12}
        >
            <CircularProgress size={100} />
        </Grid>
    )
}

export default GlobalBusy
